import styled, { keyframes } from "styled-components";

// Backdrop for the modal
export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

// Container for the feedback modal content
export const ModalContent = styled.div`
  background: #fff;
  width: 600px;
  max-width: 90%;
  height: auto;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
`;

// Header area with title and close button
export const ModalHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 2rem 0 2rem;

  h2 {
    font-size: 1.25rem;
    margin: 0;
    color: #252525;
  }
`;

// Close button inside the header
export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  color: #252525;
`;

// Container for modal tabs
export const ModalTabs = styled.div`
  display: flex;
  gap: 0.2rem;
  margin: 1rem 2rem 0 2rem;
`;

// Individual tab item with an active state
export const TabItem = styled.div`
  flex: 1;
  text-align: center;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border-bottom: 1.5px solid transparent;
  cursor: pointer;
  font-weight: 500;
  background-color: #f3f5f7;
  color: #252525;

  ${({ active }) =>
    active &&
    `
      border-bottom: 2px solid #252525;
  `}
`;

// Styling for the modal form
export const ModalForm = styled.form`
  position: relative;
`;

// Container for tab content within the modal
export const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

// Grouping for form elements
export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 1rem;
    margin-bottom: 0.25rem;
    color: #252525;
  }

  select,
  input {
    border: 1.5px solid #e1e3e7;
    border-radius: 6px;
    height: 40px;
    padding: 0 0.5rem;
    font-size: 1rem;
  }

  textarea {
    border: 1.5px solid #e1e3e7;
    border-radius: 6px;
    padding: 0.5rem;
    font-size: 1rem;
  }
`;

// Alternative grouping with vertical gap
export const GapForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

// Layout for side-by-side form groups
export const SplitInputs = styled.div`
  display: flex;
  gap: 1rem;

  & > ${FormGroup} {
    flex: 1;
  }
`;

// Container for date inputs or similar grouped elements
export const ModalDates = styled.div`
  display: flex;
  gap: 1rem;

  & > ${FormGroup} {
    flex: 1;
  }
`;

// A container for checkboxes with label(s)
export const CheckboxField = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;
`;

// Upload box styling for file input
export const UploadBox = styled.div`
  border: 1.5px dashed #e1e3e7;
  border-radius: 6px;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  position: relative;
  background-color: #f3f5f7;

  input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
  }
`;

// Footer container with a top border
export const ModalFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 1rem 0 0 0;
  border-top: 1.5px solid #e1e3e7;
`;

// Utility spacing helpers
export const TopMargin = styled.div`
  margin-top: 1rem;
`;

export const AllMargin = styled.div`
  margin: 1rem;
`;

// Text styling examples
export const TextBlack = styled.span`
  color: #252525;
`;

// Success message styling
export const SuccessMessage = styled.div`
  color: #08A36F;
  font-size: 1rem;
`;

// Error message styling
export const ErrorMessage = styled.div`
  color: #E9540D;
  background-color: rgba(255, 77, 77, 0.15);
  padding: 0.5rem 1rem;
  border-radius: 6px;
  margin: 0.5rem 2rem 0 2rem;
`;

// Keyframes animation for a spinner
const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Spinner element
export const Spinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1D2A4D;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: ${spin} 1s linear infinite;
  position: absolute;
  top: 35%;
  left: 45%;
`;

export const CancelButton = styled.button`
  background-color: #fff;
  border: 1.5px solid #e1e3e7;
  color: #252525;
  border-radius: 6px;
  height: 40px;
  padding: 0 1rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;

  &:hover {
    background-color: #f3f5f7;
  }
`;

export const ContinueButton = styled.button`
  background-color: #E9540D;
  border: none;
  border-radius: 6px;
  height: 40px;
  padding: 0 1rem;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
  font-size: 1rem;

  &:hover {
    background-color: #1D2A4D;
  }
`;

